module.exports = __webpack_public_path__ + "static/img/image-2.316d7be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image-2.jpg
// module id = 146
// module chunks = 1